import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWA } from '@/hooks/usePWA';

export function InstallPrompt() {
  const { showInstallPrompt, promptInstall, dismissInstallPrompt, isInstalled } = usePWA();

  // Não mostrar se já está instalado
  if (isInstalled || !showInstallPrompt) return null;

  // Detectar iOS (Safari não suporta beforeinstallprompt)
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

  const handleInstall = async () => {
    const success = await promptInstall();
    if (success) {
      dismissInstallPrompt();
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 
                    bg-background border-2 border-primary rounded-lg shadow-2xl 
                    p-4 animate-in slide-in-from-bottom duration-300">
      <button
        onClick={dismissInstallPrompt}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-muted transition"
        aria-label="Fechar"
      >
        <X className="w-4 h-4" />
      </button>

      <div className="flex items-start gap-3">
        <img 
          src="/icons/icon-192x192.png" 
          alt="SG7" 
          className="w-12 h-12 rounded-lg flex-shrink-0"
        />
        
        <div className="flex-1">
          <h3 className="font-bold text-lg mb-1">Install SG7</h3>
          
          {isIOS ? (
            <>
              <p className="text-sm text-muted-foreground mb-3">
                To install on iOS: tap <span className="inline-block">⬆️</span> and 
                select <strong>"Add to Home Screen"</strong>.
              </p>
              <Button onClick={dismissInstallPrompt} variant="outline" size="sm" className="w-full">
                Got it
              </Button>
            </>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mb-3">
                Add SG7 to your device for quick access and real-time notifications.
              </p>
              <div className="flex gap-2">
                <Button onClick={handleInstall} size="sm" className="flex-1">
                  Install
                </Button>
                <Button onClick={dismissInstallPrompt} variant="outline" size="sm">
                  Not now
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
